/**
 * @generated SignedSource<<0801e123f84d532e86d2828e7c7b4978>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConfigScreen = "basic" | "l_layout" | "media_only" | "multi_column_schedule" | "multi_day_schedule" | "mvp" | "nutrition" | "schedule_only" | "weather" | "%future added value";
export type DeviceScheduleItemMode = "config" | "playlist" | "%future added value";
export type DeviceScheduleScreen_EditItemQuery$variables = {
  deviceScheduleItemId: string;
};
export type DeviceScheduleScreen_EditItemQuery$data = {
  readonly node: {
    readonly __typename: "DeviceScheduleItem";
    readonly endsAt: string;
    readonly id: string;
    readonly mode: DeviceScheduleItemMode;
    readonly playlist: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly screenConfig: {
      readonly configType: ConfigScreen;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly startsAt: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type DeviceScheduleScreen_EditItemQuery = {
  response: DeviceScheduleScreen_EditItemQuery$data;
  variables: DeviceScheduleScreen_EditItemQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceScheduleItemId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "deviceScheduleItemId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startsAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endsAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ScreenConfig",
  "kind": "LinkedField",
  "name": "screenConfig",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "configType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Playlist",
  "kind": "LinkedField",
  "name": "playlist",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeviceScheduleScreen_EditItemQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "type": "DeviceScheduleItem",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeviceScheduleScreen_EditItemQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "type": "DeviceScheduleItem",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8825c001983ecd31c691dddc2c536366",
    "id": null,
    "metadata": {},
    "name": "DeviceScheduleScreen_EditItemQuery",
    "operationKind": "query",
    "text": "query DeviceScheduleScreen_EditItemQuery(\n  $deviceScheduleItemId: ID!\n) {\n  node(id: $deviceScheduleItemId) {\n    __typename\n    ... on DeviceScheduleItem {\n      id\n      startsAt\n      endsAt\n      mode\n      screenConfig {\n        id\n        name\n        configType\n      }\n      playlist {\n        id\n        name\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ce9e32bfb780ae53fa18fd442ea8d85";

export default node;
